import React from 'react'
import { useSelector } from 'react-redux'
import ErrorMessagesWindow from './errorValidationWindow'

const DisplayError = ({ tabName }) => {
    const tabValidationErrors = useSelector((state) => state?.ValidationErrors[tabName]) || {}
    const displayErr = Object?.entries(tabValidationErrors)?.map(([id, value]) => ({ id, msg: value?.msg })) || []
    return displayErr.length!=0 ? <ErrorMessagesWindow errors={displayErr} /> : null
}

export default React.memo(DisplayError)